import type { DocumentSnapshot, QueryConstraint, QueryDocumentSnapshot } from 'firebase/firestore/lite';
import type { Draft } from 'immer';
import { jotaiStore } from '../store';
import type { createMapAtom } from './mapAtom';

export function setSingle<TEntitiy extends { id: string }>(entity: Draft<TEntitiy>, atom: ReturnType<typeof createMapAtom<TEntitiy>>) {
    jotaiStore.set(atom, draft => {
        draft[entity.id] = entity;
    });
}

export function setMultiple<TEntitiy = unknown>(entitys: Record<string, TEntitiy>, atom: ReturnType<typeof createMapAtom<TEntitiy>>) {
    jotaiStore.set(atom, draft => {
        Object.assign(draft, entitys);
    });
}

export interface FetchEntitiesPayload<T> {
    lowerBound?: DocumentSnapshot<T> | null;
    fetchLimit?: number;
    queryConstraints?: QueryConstraint[];
}

export interface FetchEntitiesResult<T> {
    ids: string[];
    entitiesData: Record<string, T>;
    lastDoc: QueryDocumentSnapshot<T> | null;
    hasMore: boolean;
}
